module.exports = __webpack_public_path__ + ".well-known/img/merchant-banner.46642311.png";